import '../../css/sections/LinkedInSection.css';
import { motion } from "framer-motion";
import { TextGenerateEffect } from "../ui/text-generate-effect";

function LinkedInSection() {
    return (
        <motion.div className={`linkedin-container`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true, amount: 0.04 }}>
            <div className='linkedin-text'>
                <div className='linkedin-heading'>
                    <h1><span className='special-font' style={{ fontStyle: "italic" }}>BEYOND</span> THE WORK</h1>
                    <TextGenerateEffect
                        words="Shifting Perspectives, Sharing Lessons, And Documenting The Daily Hustle. Step Into My Mindset And See How Consistency Transforms Into Results."
                    />
                </div>
            </div>
            <div className='widget'>
                <iframe
                    src="https://widgets.sociablekit.com/linkedin-profile-posts/iframe/25690364"
                    frameborder="0"
                    width="100%"
                    height="520px"
                    title="LinkedIn profile posts widget"
                >
                </iframe>
            </div>
        </motion.div>
    )
}

export default LinkedInSection;
